// extracted by mini-css-extract-plugin
export default {"popupHeading":"heading_popupHeading__t+Q+r","name":"heading_name__h98gR","subtitle":"heading_subtitle__7kdL1","edit":"heading_edit__I1qIN"};